import React, { Component } from "react";
import { Navbar, Nav } from "reactstrap";
import Logo from "../../assets/icons/selectlogo.png";
import arrow_left from "../../assets/icons/filter2.png";
import arrow_right from "../../assets/icons/filter1.png";
import { Link, withRouter } from "react-router-dom";
import "./TopNav.scss";
import bgimg from "./SelectFashion.png";
import { MobileView, BrowserView } from "react-device-detect";
import userClicked from "../../assets/icons/userclicked.png";
import userUnClicked from "../../assets/icons/userunclicked.png";
import importUnClicked from "../../assets/icons/importunclicked.png";
import omgUnClicked from "../../assets/icons/omgunclicked.png";
import saleUnClicked from "../../assets/icons/saleunclicked.png";
import ReactTooltip from "react-tooltip";
import ReactDOM from "react-dom";
import $ from "jquery";

class TopNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      user: true,
      query: "",
      data: [],
      filteredData: [],
      searchItem: false
    };
  }
  handleInputChange = event => {
    const query = event.target.value;

    this.setState(prevState => {
      const filteredData = prevState.data.filter(element => {
        return element.Brand_Name.toLowerCase().includes(query.toLowerCase());
      });

      return {
        query,
        filteredData
      };
    });
  };
  showDiv = () => {
    this.setState({ searchItem: !this.state.searchItem });
  };
  toggleSideBar = () => {
    this.setState({ expanded: !this.state.expanded });
  };
  // getData = () => {
  //   fetch(
  //     `http://brands.us-east-2.elasticbeanstalk.com/api/product/GetBrandName`
  //   )
  //     .then(response => response.json())
  //     .then(data => {
  //       const { query } = this.state;
  //       const filteredData = data.filter(element => {
  //         return element.Brand_Name.toLowerCase().includes(query.toLowerCase());
  //       });

  //       this.setState({
  //         data,
  //         filteredData
  //       });
  //     });
  // };

  componentWillMount() {
    document.addEventListener("click", this.handleClickOutside, true);
    $(document).ready(function() {
      $(".tax-wrap input").focus(function() {
        $(".hide-tax").show("fast");
        //return false;
      });

      $(".tax-wrap input").blur(function() {
        if (!$(this).val()) {
          $(".hide-tax").hide("slow");
        }
      });
    }); //end
  //  this.getData();
  }
  handleClickOutside = event => {
    // const domNode = ReactDOM.findDOMNode(this);
    // if (!domNode || !domNode.contains(event.target)) {
    //     $('.hide-tax').hide();
    // }
  };

  render() {
    return (
      <div>
        <div expand="md" className="TopNavBar">
          {/* <MobileView>
                        <div className='TopNavLeftDiv'>

                            <span className="arrow_wrapper" onClick={this.toggleSideBar} style={{ display: `${this.state.expanded ? "" : 'none'}` }}>
                                <img style={{ width: "30px" }} alt="Arrow" src={arrow_left} onClick={this.props.expandSideNav} />
                            </span>
                            <span className="arrow_wrapper" onClick={this.toggleSideBar} style={{ display: `${this.state.expanded ? "none" : ''}` }}>
                                <img style={{ width: "30px" }} alt="Arrow" src={arrow_right} onClick={this.props.expandSideNav} />
                            </span>
                        </div>
                    </MobileView> */}
          <MobileView>
            <div
              className="actionLink"
              style={{
                textAlign: "center",
                width: " 100%",
                position: "absolute",
                lineHeight: " 2rem"
              }}
            >
              <Link
                to="/"
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontFamily: "Brush Script MT, Brush Script Std, cursive",
                  fontSize: "2rem"
                }}
              >
                {this.props.heading}
              </Link>
            </div>
          </MobileView>
          <BrowserView>
            <div className="selectfashionlogo">
              <Link to="/">
                <img className="selectLogoimage" src={Logo}></img>
              </Link>
            </div>
          </BrowserView>
          <div className="LWmhU _0aCwM">
            {/* <input className="XTCLo x3qfX" type="text" onChange={this.handleInputChange} autoCapitalize="none" placeholder="Search" />
             */}
            <BrowserView>
              <div className="tax-wrap">
                <input
                  name="field"
                  id="field"
                  className="delprefix XTCLo x3qfX"
                  type="text"
                  onChange={this.handleInputChange}
                  autoCapitalize="none"
                  placeholder="Search"
                />
              </div>

              <div
                style={{ display: "none" }}
                id="style-2"
                className="hide-tax searchdiv"
              >
                {this.state.filteredData.map(i => (
                  <Link className="searchNav" to={`/brand/${i.Brand_Name}`}>
                    <div className="z556c">
                      <div
                        className="RR-M- h5uC0 g9vPa"
                        role="button"
                        tabindex="0"
                      >
                        <canvas
                          className="CfWVH"
                          height="53"
                          width="53"
                          style={{
                            position: "absolute",
                            top: "-5px",
                            left: "-5px",
                            width: "42px",
                            height: "42px"
                          }}
                        ></canvas>
                        <span
                          className="_2dbep "
                          role="link"
                          tabindex="0"
                          style={{ width: "32px", height: "32px" }}
                        >
                          <img
                            className="_6q-tv"
                            src="https://instagram.fisb6-1.fna.fbcdn.net/vp/b09fb5ff6a2622b6dde27886cdf07946/5DCF5498/t51.2885-19/s150x150/47581969_2323985807880248_3430889046493102080_n.jpg?_nc_ht=instagram.fisb6-1.fna.fbcdn.net"
                            alt="khaadi's profile picture"
                            style={{
                              display: `${
                                i.Brand_Name == "Khaadi" ? "" : "none"
                              }`
                            }}
                          />

                          <img
                            className="_6q-tv"
                            src="https://instagram.flhe3-1.fna.fbcdn.net/vp/8da6a86af2905cafb184eaa521f8c3cb/5DE203CC/t51.2885-19/s150x150/66405424_1369384183218954_5692550208169181184_n.jpg?_nc_ht=instagram.flhe3-1.fna.fbcdn.net"
                            alt="gulahmed's profile picture"
                            style={{
                              display: `${
                                i.Brand_Name == "GulAhmed" ? "" : "none"
                              }`
                            }}
                          />

                          <img
                            className="_6q-tv"
                            src="https://instagram.flhe3-1.fna.fbcdn.net/vp/8b3abaaeeaad78f5c4d3c98a3c987399/5DD4D882/t51.2885-19/s150x150/44378282_2428339197181972_414195337377349632_n.jpg?_nc_ht=instagram.flhe3-1.fna.fbcdn.net"
                            alt="Sapphire's profile picture"
                            style={{
                              display: `${
                                i.Brand_Name == "Sapphire" ? "" : "none"
                              }`
                            }}
                          />

                          <img
                            className="_6q-tv"
                            src="https://instagram.flhe3-1.fna.fbcdn.net/vp/a5b0dcfb0ea05b8ee5edb84777be400d/5DE1E5F0/t51.2885-19/s150x150/57044386_2355121754766463_6875754749791043584_n.jpg?_nc_ht=instagram.flhe3-1.fna.fbcdn.net"
                            alt="Ittehad textiles profile picture"
                            style={{
                              display: `${
                                i.Brand_Name == "Ittehad Textiles" ? "" : "none"
                              }`
                            }}
                          />

                          <img
                            className="_6q-tv"
                            src="https://instagram.flhe3-1.fna.fbcdn.net/vp/1b67839feac7a4bd493a105d510b801d/5DB33E39/t51.2885-19/s150x150/65267529_859589584397525_709048209502109696_n.jpg?_nc_ht=instagram.flhe3-1.fna.fbcdn.net"
                            alt="J. | JunaidJamshed profile picture"
                            style={{
                              display: `${
                                i.Brand_Name == "J. | JunaidJamshed"
                                  ? ""
                                  : "none"
                              }`
                            }}
                          />

                          <img
                            className="_6q-tv"
                            src="https://instagram.fisb6-1.fna.fbcdn.net/vp/9efddc0f084e6ae6252e870647d4e3fd/5DB68DB4/t51.2885-19/s150x150/53250688_618698815243976_174606217472114688_n.jpg?_nc_ht=instagram.fisb6-1.fna.fbcdn.net"
                            alt="Limelight profile picture"
                            style={{
                              display: `${
                                i.Brand_Name == "Limelight" ? "" : "none"
                              }`
                            }}
                          />
                          <img
                            className="_6q-tv"
                            src="https://instagram.flhe3-1.fna.fbcdn.net/vp/763babe29ff7775d4531104dd6089c60/5DE8BFDA/t51.2885-19/39326457_482555265546532_9024037897363259392_n.jpg?_nc_ht=instagram.flhe3-1.fna.fbcdn.net"
                            alt="Waniya profile picture"
                            style={{
                              display: `${
                                i.Brand_Name == "Waniya" ? "" : "none"
                              }`
                            }}
                          />
                        </span>
                      </div>

                      {/* <img className="searchImage" src={logo}></img> */}
                      <h3 className="Ap253 searchDiv">{i.Brand_Name}</h3>
                    </div>
                  </Link>
                ))}
              </div>
            </BrowserView>
            
          </div>

          <BrowserView style={{ float: "right", width: "24%" }}>
            <div style={{ float: "right" }}>
              <Link data-tip="Sale" to="/sale" className="iconNav">
                <img alt="Arrow" src={saleUnClicked} />
                <ReactTooltip place="bottom" type="dark" effect="solid" />
              </Link>

              <Link data-tip="Popular" to="/popular" className="iconNav">
                <img alt="Arrow" src={omgUnClicked} />
              </Link>
              <Link data-tip="Profile" to="/user" className="iconNav">
                <img alt="Arrow" src={userUnClicked} />
              </Link>
            </div>
          </BrowserView>
        </div>
      </div>
    );
  }
}

export default TopNav;
